import { FileArchive } from "lucide-react";

export default function AuthLayout({ children }) {
  return (
    <main className="max-w-6xl mx-auto px-4 sm:px-6 lg:px-8 py-12 grid lg:grid-cols-2 gap-12 items-center" data-testid="auth-page">
      <div className="hidden lg:flex flex-col gap-6">
        <div className="w-12 h-12 rounded-md bg-[#1E293B] text-amber-400 grid place-items-center"><FileArchive size={22} /></div>
        <h1 className="font-heading text-4xl font-extrabold tracking-tight leading-tight">
          Stop clicking every filing. <span className="text-blue-600">Zip the whole docket.</span>
        </h1>
        <p className="text-slate-600 leading-relaxed max-w-md">
          Sign in to download your linked Chrome extension, track your exports and see every case you've crawled.
        </p>
      </div>
      <div className="flex items-center justify-center">{children}</div>
    </main>
  );
}
